import {
  ConditionalFormConfig,
  ConditionalFormTicketProps,
} from './api/conditionalFormApi'

export const isFieldValueMissing = (value: unknown): boolean => {
  if (typeof value === 'string') {
    return value.length === 0
  }
  return value === undefined || value === null
}

export const getValueWithDefault = (
  value: ConditionalFormTicketProps['fieldValues'][string] | undefined,
  fieldDefinition: ConditionalFormConfig['ontologyFields'][string]
) => {
  if (
    isFieldValueMissing(value) &&
    fieldDefinition.defaultValue !== undefined
  ) {
    return fieldDefinition.defaultValue
  }
  return value
}

export const collectDefaultsForFields = (
  fieldValues: ConditionalFormTicketProps['fieldValues'],
  ontologyFields: ConditionalFormConfig['ontologyFields'],
  fields: ReadonlyArray<string>
): Partial<ConditionalFormTicketProps['fieldValues']> => {
  return fields.reduce<Partial<ConditionalFormTicketProps['fieldValues']>>(
    (acc, fieldId) => {
      const fieldDefinition = ontologyFields[fieldId]
      if (!fieldDefinition || fieldDefinition.defaultValue === undefined) {
        return acc
      }
      const currentValue = fieldValues?.[fieldId]
      if (isFieldValueMissing(currentValue)) {
        acc[fieldId] = fieldDefinition.defaultValue
      }
      return acc
    },
    {}
  )
}
